module.exports = require('./helpers/bundle-url').getBundleURL('1OwBs') + "demo.a55218d5.svg" + "?" + Date.now();